import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function ReportCard({ item, index }) {
  return (
    <Card
      sx={{
        width: "100%",
        m: "0px",
        mt: "10px",
        p: "0px",
        ":hover": {
          bgcolor: "#2892ba17",
        },
        "& .MuiCardContent-root": { p: "0.5rem" }
      }}
    >
      <CardContent
        sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={4}>
            <Typography
              color="primary"
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {item?.itemCategory}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography
              color="primary"
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              {item?.items}
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CurrencyRupeeIcon color="primary" fontSize="10px" />
            <Typography
              color="primary"
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                display: "-webkit-box",
                textAlign: "center",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {item?.amount?.toFixed(2)}
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              color="primary"
              sx={{
                textOverflow: "ellipsis",
              }}
            >
              {item?.percentage?.toFixed(2)} %
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
